// Bernie
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';

// Data
import { pageNames } from 'data/page-names';

// Stores
import { UiStore } from 'stores';

// Utils
import analyticsUtil from '../util/analytics-util';

class ForcePzController implements Controller {
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "force-pz-page" */ '../views/force-pz-page'));

  public pageId = pageNames.forcePZ;

  public path = '/:localeName/finish-account-setup';
  public exact = true;

  public routeName = 'force-pz';

  public async fetch(options: FetchOptions): Promise<Result> {
    const { stores, request } = options;

    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return {};
  }

  public async fetchPageData(): Promise<PageData> {
    const pageData: PageData = {
      title: 'Affiliate Hub Finish Account Setup',
    };

    return pageData;
  }
}

export { ForcePzController };
